
import './index.less'
import React from 'react'
const te = ['flex-start', 'center', 'flex-end']
console.log(React)
export default function Suspension(props) {
  const cardStyle = props.ifon.card
  const src = props.ifon.cardStyle.card1.headPortrait.src ? props.ifon.cardStyle.card1.headPortrait.src : 'https://i.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemaker/images/tencent_logo.png'

  return (<div className={`suspension ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}>

    <div className='suspension_seizeASeat' style={{
      paddingTop: props.ifon.paddingTop,
      paddingBottom: props.ifon.paddingBottom,
      paddingLeft: props.ifon.paddingLeft,
      paddingRight: props.ifon.paddingRight
    }}>

      {cardStyle === 0 && <div style={{
        width: '100%',
        display: 'flex',
        justifyContent: te[props.ifon.layout]
      }}>
        <div className='card' style={{
          width: props.ifon.width + '%',
          borderRadius: props.ifon.fillet,
          backgroundColor: props.ifon.cardBackColor1
        }}>
          <img src={src} className='card_img' />
          <div className='card_ifon'>
            <h3 className='ifon_title'>{props.ifon.cardStyle.card1.headPortrait.accountName ? props.ifon.cardStyle.card1.headPortrait.accountName : '腾讯'}</h3>
            <span className='ifon_tips'>{props.ifon.cardStyle.card1.headPortrait.accountDescription ? props.ifon.cardStyle.card1.headPortrait.accountDescription : '腾讯公司唯一官方账号'}</span>
          </div>
          <button className='card_button' style={{
            fontSize: props.ifon.fontSize,
            color: props.ifon.cardColor,
            backgroundColor: props.ifon.cardBackColor
          }}>{props.ifon.cardStyle.card1.text ? props.ifon.cardStyle.card1.text : '关注'}</button>
        </div>
      </div>}

      {cardStyle === 1 && <div className='button' style={{
        height: props.ifon.cardStyle.card2.height,
        width: props.ifon.width + '%',
        fontSize: props.ifon.fontSize,
        borderRadius: props.ifon.fillet,
        color: props.ifon.cardColor,
        backgroundColor: props.ifon.cardBackColor
      }}>
        {props.ifon.cardStyle.card2.text ? props.ifon.cardStyle.card2.text : '关注微信公众号'}
      </div>}

      {cardStyle === 2 && <div className='codeBox' >
        <span className='codeBox_span' style={{
          fontSize: props.ifon.cardStyle.card3.fontSize,
          color: props.ifon.cardStyle.card3.color
        }} >{props.ifon.cardStyle.card3.describe1 ? props.ifon.cardStyle.card3.describe1 : '长按保存二维码到相册 关注获取更多内容'}</span>
        <div className='code'>
          <img className='code_img' src='https://read.e.qq.com/assets/images/yuebao/wxAttentionQrCodeDefault.png' />
        </div>
        <span className='codeBox_span' style={{
          fontSize: props.ifon.cardStyle.card3.fontSize,
          color: props.ifon.cardStyle.card3.color
        }}>公众号名称</span>
      </div>}

      {cardStyle === 3 && <div className='imgBox'>
        <img className='imgBox_img' src={props.ifon.cardStyle.card4.backImage.src ? props.ifon.cardStyle.card4.backImage.src : 'https://i.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemaker/images/wxAttentionHolder.png'} />
      </div>}

      {cardStyle !== 2 && props.ifon.isGuide && <div className='guideLayer'>
        <img className='guideLayer_img' src='https://read.e.qq.com/assets/images/yuebao/guide-1.png' />
      </div>}

    </div>
  </div >)
}
